import { createAxios } from './httpService';

const axiosInstance = createAxios();

export const AuthService = {
  login: ({ username, password }) => {
    return axiosInstance.post(`/auth/login`, { username, password });
  },
};
